import gsap from 'gsap';
import appStore from '../utils/state';

export default class MainUnderlay extends HTMLElement {
  private showTl: gsap.core.Timeline | null = null;
  private hideTl: gsap.core.Timeline | null = null;

  private unsubscribeFromMainNavToggle: (() => void) | null = null;
  private unsubscribeFromSearchModalOpen: (() => void) | null = null;

  private onClickBound = this.onClick.bind(this);
  private onMainNavToggleBound = this.onMainNavToggle.bind(this);
  private onSearchModalOpenBound = this.onSearchModalOpen.bind(this);

  connectedCallback(): void {
    this.addEventListeners();
    this.subscribe();
  }

  addEventListeners(): void {
    this.addEventListener('click', this.onClickBound);
  }

  removeEventListeners(): void {
    this.removeEventListener('click', this.onClickBound);
  }

  subscribe(): void {
    this.unsubscribeFromMainNavToggle = appStore.subscribeKey('isMainNavOpen', this.onMainNavToggleBound);
    this.unsubscribeFromSearchModalOpen = appStore.subscribeKey('isSearchModalOpen', this.onSearchModalOpenBound);
  }

  unsubscribe(): void {
    if (this.unsubscribeFromMainNavToggle) {
      this.unsubscribeFromMainNavToggle();
      this.unsubscribeFromMainNavToggle = null;
    }
    if (this.unsubscribeFromSearchModalOpen) {
      this.unsubscribeFromSearchModalOpen();
      this.unsubscribeFromSearchModalOpen = null;
    }
  }

  onClick(): void {
    appStore.actions.closeMainNav();
    appStore.actions.closeSearchModal();
  }

  onMainNavToggle(): void {
    const isMainNavOpen = appStore.getState().isMainNavOpen;

    if (isMainNavOpen) {
      this.show();
    } else if (!appStore.getState().isSearchModalOpen && !isMainNavOpen) {
      this.hide();
    }
  }

  onSearchModalOpen(): void {
    const isSearchModalOpen = appStore.getState().isSearchModalOpen;

    if (isSearchModalOpen) {
      this.show();
    } else if (!appStore.getState().isMainNavOpen && !isSearchModalOpen) {
      this.hide();
    }
  }

  show(): void {
    if (this.hideTl) {
      this.hideTl.kill();
    }
    if (this.showTl) {
      this.showTl.kill();
    }
    this.showTl = gsap.timeline();
    this.showTl.set([window.document.body], { overflow: 'hidden' }, 0);
    this.showTl.fromTo(this, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5, ease: 'power2.out' }, 0);
  }

  hide(): void {
    if (this.showTl) {
      this.showTl.kill();
    }
    if (this.hideTl) {
      this.hideTl.kill();
    }
    this.hideTl = gsap.timeline();
    this.hideTl.set([window.document.body], { clearProps: 'overflow' }, 0);
    this.hideTl.to(this, { autoAlpha: 0, duration: 0.2, ease: 'power2.out' }, 0);
  }

  disconnectedCallback(): void {
    this.unsubscribe();
    this.removeEventListeners();

    if (this.showTl) {
      this.showTl.kill();
    }
    if (this.hideTl) {
      this.hideTl.kill();
    }
  }
}

customElements.define('main-underlay', MainUnderlay);
